import { render } from "./AssistantMascot.vue?vue&type=template&id=d052209e"
import script from "./AssistantMascot.vue?vue&type=script&lang=js"
export * from "./AssistantMascot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__